const _pulse = {"0%, 100%":{"opacity":1},"50%":{"opacity":0.5}}
const _shimmer = {"0%":{"background-position":"-400px 0"},"100%":{"background-position":"400px 0"}}
const config = { "pulse": _pulse, "shimmer": _shimmer,  }
export { config as default, _pulse, _shimmer }